export default function jsonSerializer() {
  const toJSON = (obj) => {
    return JSON.stringify(obj);
  }

  const fromJSON = (json) => {
    return JSON.parse(json);
  }

  return {
    toJSON,
    fromJSON,
  };
}